<template>
<div>
    <accounting-books-receipt-standart-form :getAccountingBooksReceiptStandartList="getAccountingBooksReceiptStandartList" :getAccountingBooksReceiptList="getAccountingBooksReceiptList" :getAccountingBooksList="getAccountingBooksList" ref="accountingBooksReceiptStandartFormModal"></accounting-books-receipt-standart-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search_name')" type="text" class="d-inline-block" />
                    </div>
                </b-form-group>
            </div>
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button   v-if="isRecordLocked" style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('accountingBooksReceiptStandart.add') }}</b-button>
                        <b-button style="float:right;" class="ml-1" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="accountingBooksReceiptStandartTable" ref="accountingBooksReceiptStandartTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" 
    :search-options="{ enabled: true, externalQuery: searchTerm }" 
    :select-options="{ enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', clearSelectionText: 'clear',
        disableSelectInfo: true, selectAllByGroup: true, }" 
    :pagination-options="{ enabled: true, perPage: pageLength }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'accountingTransactionDetailType'" class="text-nowrap">
                {{ $t('accountingBooksReceiptStandart.accounting_transaction_detail_type') }} 
                <p></p>
            </span>
            <span v-else-if="props.column.field === 'accountingNo'" class="text-nowrap">
                {{ $t('accountingBooksReceiptStandart.account_no') }} 
                <p></p>
            </span>
            <span v-else-if="props.column.field === 'accountingName'" class="text-nowrap">
                {{ $t('accountingBooksReceiptStandart.account_name') }}
                <p></p>
            </span>
            <span v-else-if="props.column.field === 'amount'" class="text-nowrap">
                {{ $t('accountingBooksReceiptStandart.total') }}
            </span>
            <span v-else-if="props.column.field === 'amountCv'" class="text-nowrap">
                {{ $t('accountingBooksReceiptStandart.total_tl') }}
                <div style="color: red;">
                    <strong>{{ $t('accountingBooksReceiptStandart.balance') }} :  {{ $formatAmount(totalAmountCv) }}</strong>
                </div>
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template> 
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button  v-if="isRecordLocked" v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>

        <!-- pagination -->
        <template
      slot="pagination-bottom"
      slot-scope="props"
  >
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex align-items-center mb-0 mt-1">
        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
        <b-form-select
            v-model="pageLength"
            :options="['10','50','100', '1000']"
            class="mx-1"
            @input="(value)=>props.perPageChanged({currentPerPage:value})"
        />
        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
      </div>
      <div>
        <b-pagination
            :value="1"
            :total-rows="props.total"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value)=>props.pageChanged({currentPage:value})"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </div>
  </template>
    </vue-good-table>
</div>
</template>

  
<script>
export default {
    props: {
        getAccountingBooksList: {
            type: Function
        },
        getAccountingBooksReceiptList: {
            type: Function
        },
        accountingTransactionId: {
            type: Number
        },
        subsidiaryLedgerId: {
            type: Number
        },
        isRecordLocked: {
            type: Boolean
        }
    },
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            columns: [
            {
                    label: this.$t('accountingBooksReceiptStandart.accounting_transaction_detail_type'),
                    field: `accountingTransactionDetailType`,
                },
            {
                    label: this.$t('accountingBooksReceiptStandart.account_no'),
                    field: `accountingNo`,
                },
                {
                    label: this.$t('accountingBooksReceiptStandart.account_name'),
                    field: `accountingName`,
                },
                {
                    label: this.$t('accountingBooksReceiptStandart.total'),
                    field: `amount`,
                    formatFn: this.$formatAmount
                },
                {
                    label: this.$t('accountingBooksReceiptStandart.total_tl'),
                    field: `amountCv`,
                    formatFn: this.$formatAmount
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            totalAmountEmitted: 0
        }
    },
    computed: {
        totalAmountCv() {
            if(this.rows != null){
                return (this.rows.filter(p=> p.accountingTransactionDetailTypeId == 1).reduce((sum, row) => sum + (row.amountCv || 0), 0) - this.rows.filter(p=> p.accountingTransactionDetailTypeId == 2).reduce((sum, row) => sum + (row.amountCv || 0), 0))
            }
            else{
                return 0
            }
        }
    },
    mounted() {
        this.getAccountingBooksReceiptStandartList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'AccountingTransactionDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getAccountingBooksReceiptStandartList()
                            this.getAccountingBooksReceiptList()
                            this.getAccountingBooksList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.accountingBooksReceiptStandartFormModal.showInfo(id, this.subsidiaryLedgerId, this.accountingTransactionId, this.isRecordLocked)
        },
        async getAccountingBooksReceiptStandartList() {
            this.rows = []
            const controller = {
                name: 'AccountingTransactionDetail',
                actionName: 'GetAccountingTransactionDetailListByAccountingTransactionId'
            }
            const data = {
                id: this.accountingTransactionId
            }
            const payload = {
                data: data,
                controller: controller
            }
            const response =  await this.$store.dispatch('moduleAuth/customService', payload);
                if (response.data.resultStatus == true) {
                    if(response.data.accountingTransactionDetailList != null){
                        this.rows = response.data.accountingTransactionDetailList
                        if(response.data.accountingTransactionDetailList.length > 0 ){
                             this.totalAmountEmitted = response.data.accountingTransactionDetailList
                            .filter(item => item.accountingTransactionDetailTypeId === 1)
                            .reduce((sum, item) => sum + item.amountCv, 0);
                            this.$emit('totalAmountEmitted', parseFloat(this.totalAmountEmitted).toFixed(2)); 
                         }else{
                            this.$emit('totalAmountEmitted', 0); 
                        }
                    } else this.rows = []
                    this.total = response.data.total
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        exportExcel() {
            const controller = {
                name: 'AccountingBooksReceiptStandart',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("AccountingBooksReceiptStandart", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>
  
<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
.total-summary-card {
    font-size: 14px;
    background-color: #f8f9fa;
    border: 1px solid #d1d3e2;
    border-radius: 0.5rem;
}
</style>
